<lib-overlayer
  popUpID="mprd-modem-choice-delete-ont-modal"
  [displaySubTitle]="false"
  [options]="{ backDrop: true, closeViaBackdrop: true }"
  [showModal]="open"
  (onClose)="onClose()"
>
  <ng-container Title>
    {{ "modem-choice.ont-delete-title" | translate }}
  </ng-container>
  <ng-container Content>
    <p>
      {{ "modem-choice.ont-delete-description" | translate }}
    </p>
  </ng-container>
  <ng-container Footer>
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-order-m2">
        <button
          class="rs-btn rs-btn-nl-so"
          (click)="onDelete()"
          [class.rs-btn-waiting]="pending"
          [attr.role]="pending ? 'alert' : null"
          [attr.aria-live]="pending ? 'polite' : null"
          [attr.aria-busy]="pending"
          [attr.aria-label]="pending ? ('common.loading' | translate) : null"
        >
          {{ "modem-choice.ont-delete-confirm" | translate }}
          <span
            *ngIf="pending"
            class="rs-btn-waiting-dots"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <button
          class="rs-btn rs-btn-second rs-btn-nl-m close-reveal-modal"
          (click)="onClose()"
          [disabled]="pending"
        >
          {{ "modem-choice.ont-delete-cancel" | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</lib-overlayer>
